import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import {
  AccessRole,
  CompanyStakeholderDto,
  HumanStakeholderDto,
} from '../../types/stakeholder.types';
import { useAppMutation } from '../use-app-mutation.hook';
import { useInvalidateQueries } from '../use-invalidate-queries.hook';

export const useUpdate = () => {
  const { invalidateQuery } = useInvalidateQueries(
    QueryKey.GET_SELECTED_COMPANY,
    QueryKey.GET_TEAM,
  );
  const { mutate: update, isPending } = useAppMutation([QueryKey.PATCH_STAKEHOLDER], {
    mutationFn: ({
      companyId,
      data,
      stakeholderId,
    }: {
      companyId: string;
      data: { accessRole?: AccessRole | null } & (CompanyStakeholderDto | HumanStakeholderDto);
      stakeholderId: string;
    }) =>
      ApiService.patch(
        { endpoint: BackendRoute.COMPANIES, routePath: [companyId, 'stakeholders', stakeholderId] },
        { body: data },
      ),

    onSuccess: () => {
      invalidateQuery();
    },
  });
  return { update, isPending };
};
